<template>
  <div class="resource-section">
    <div class="message-info">
      <img
        class="avatar"
        src="@/assets/icons/zytj.png"
        alt="AI"
      />
      <div class="resource-title">资源推荐</div>
    </div>
    <div class="resource-container">
      <!-- VR资源 -->
      <div class="resource-box vr-box">
        <div class="resource-scroll-wrapper">
          <div
            class="scroll-arrow left"
            @click="scrollLeft('vrScroll')"
            @mouseenter="hoverLeftVR = true"
            @mouseleave="hoverLeftVR = false"
          >
            <img :src="hoverLeftVR ? arrowLeftHover : arrowLeft" />
          </div>

          <div class="resource-scroll" ref="vrScroll">
            <div
              v-for="(item, index) in vrList"
              :key="'vr-' + index"
              class="resource-item"
              @click="openModal(item, 'web')"
            >
              <img :src="item.img" />
              <div class="resource-caption">{{ item.title }}</div>
            </div>
          </div>

          <div
            class="scroll-arrow right"
            @click="scrollRight('vrScroll')"
            @mouseenter="hoverRightVR = true"
            @mouseleave="hoverRightVR = false"
          >
            <img :src="hoverRightVR ? arrowRightHover : arrowRight" />
          </div>
        </div>
      </div>

      <!-- 讲课视频 -->
      <div class="resource-box video-box">
        <div class="resource-scroll-wrapper">
          <div
            class="scroll-arrow left"
            @click="scrollLeft('videoScroll')"
            @mouseenter="hoverLeftVideo = true"
            @mouseleave="hoverLeftVideo = false"
          >
            <img :src="hoverLeftVideo ? arrowLeftHover : arrowLeft" />
          </div>

          <div class="resource-scroll" ref="videoScroll">
            <div
              v-for="(item, index) in videoList"
              :key="'video-' + index"
              class="resource-item"
              @click="openModal(item, 'video')"
            >
              <img :src="item.img" />
              <div class="resource-caption">{{ item.title }}</div>
            </div>
          </div>

          <div
            class="scroll-arrow right"
            @click="scrollRight('videoScroll')"
            @mouseenter="hoverRightVideo = true"
            @mouseleave="hoverRightVideo = false"
          >
            <img :src="hoverRightVideo ? arrowRightHover : arrowRight" />
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出层 Modal -->
    <div v-if="modalVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-box">
        <div class="modal-header">
          <span>{{ modalTitle }}</span>
          <div class="modal-tools">
            <button class="fullscreen-btn" @click="toggleFullscreen">⛶</button>
            <button class="modal-close" @click="closeModal">×</button>
          </div>
        </div>
        <div class="modal-body">
          <video
            ref="modalVideo"
            v-if="modalType === 'video'"
            :src="modalSrc"
            controls
            autoplay
            style="width: 100%"
          ></video>

          <iframe
            ref="modalIframe"
            v-if="modalType === 'web'"
            :src="modalSrc"
            frameborder="0"
            style="width: 100%; height: 400px"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResourceSection',
    props: {
      videoList: {
        type: Array,
        default: () => []
      },
      vrList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        modalVisible: false,
        modalType: '',       // 'video' or 'web'
        modalTitle: '',
        modalSrc: '',

        hoverLeftVideo: false,
        hoverRightVideo: false,
        hoverLeftVR: false,
        hoverRightVR: false,
        zyImg: require('@/assets/zy.png'),
        jkImg: require('@/assets/jk.png'),
        arrowLeft: require('@/assets/icons/arrow-left.png'),
        arrowLeftHover: require('@/assets/icons/arrow-left-hover.png'),
        arrowRight: require('@/assets/icons/arrow-right.png'),
        arrowRightHover: require('@/assets/icons/arrow-right-hover.png')
      }
    },
    methods: {
      scrollLeft(refName) {
        this.$refs[refName].scrollBy({ left: -260, behavior: 'smooth' })
      },
      scrollRight(refName) {
        this.$refs[refName].scrollBy({ left: 260, behavior: 'smooth' })
      },
      resetScroll() {
        this.$refs.videoScroll.scrollTo({ left: 0, behavior: 'smooth' })
        this.$refs.vrScroll.scrollTo({ left: 0, behavior: 'smooth' })
      },
      openModal(item, type) {
        this.modalType = type
        this.modalTitle = item.title
        if(item.path.includes("https://www.keming365.com/user/showPPT")){
          this.modalSrc = item.path.replace("https://www.keming365.com/user/showPPT", "https://yq.keming365.com/webclient")
        }else if(item.path.includes("http://www.keming365.com/user/showPPT")){
          this.modalSrc = item.path.replace("http://www.keming365.com/user/showPPT", "https://yq.keming365.com/webclient")
        }else if(item.path.includes("http://keming365.com/user/showPPT")){
          this.modalSrc = item.path.replace("http://keming365.com/user/showPPT", "https://yq.keming365.com/webclient")
        }else if(item.path.includes("https://keming365.com/user/showPPT")){
          this.modalSrc = item.path.replace("https://keming365.com/user/showPPT", "https://yq.keming365.com/webclient")
        }else{
          this.modalSrc = item.path;
        }
        this.modalVisible = true
      },
      closeModal() {
        this.modalVisible = false
        this.modalSrc = ''
      },
      scrollLeft(id) {
        this.$refs[id].scrollLeft -= 260
      },
      scrollRight(id) {
        this.$refs[id].scrollLeft += 260
      },
      toggleFullscreen() {
        this.$nextTick(() => {
          let el = null;
          if (this.modalType === 'video') {
            el = this.$refs.modalVideo;
          } else if (this.modalType === 'web') {
            el = this.$refs.modalIframe;
          }

          if (el && el.requestFullscreen) {
            el.requestFullscreen();
          } else if (el && el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen(); // Safari
          } else if (el && el.msRequestFullscreen) {
            el.msRequestFullscreen(); // IE
          } else {
            alert("该浏览器不支持全屏功能");
          }
        });
      }
    }
  }
</script>
<style scoped>
  .resource-section {
    width: 100%;
    background: #ffffff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06); /* 卡片投影 */
  }

  .resource-title {
    font-size: 19px;
    font-weight: 400;
    color: #4c659f;
  }

  .resource-container {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: nowrap;
  }

  .resource-box {
    width: 48%;
    min-width: 320px;
    position: relative;
    height: 260px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  /* 背景图 */
  .video-box {
    background: url('~@/assets/jk.png') no-repeat center center; /* 替换为讲课视频背景图 */
    background-size: contain;
  }
  .vr-box {
    background: url('~@/assets/zy.png') no-repeat center center;  /* 替换为VR资源背景图 */
    background-size: contain;
  }

  /* 嵌入式滚动框容器 */
  .resource-scroll-wrapper {
    position: relative;
    width: 535px;
    display: flex;
    align-items: center;
    margin: 30px auto;
  }

  /* 滚动区 */
  .resource-scroll {
    display: flex;
    height: 156px;
    gap: 30px;
    overflow-x: auto;
    scroll-behavior: smooth;
    flex: 1;
    scrollbar-width: none;
    /*justify-content: center;*/
    margin: 0 auto;
  }
  .resource-scroll::-webkit-scrollbar {
    display: none;
  }

  /* 卡片样式 */
  .resource-item {
    flex: 0 0 220px;
    max-width: 220px;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.2s;
  }
  .resource-item:hover {
    transform: translateY(-4px);
  }
  .resource-item img {
    width: 100%;
    height: 100px;
    object-fit: cover;
  }
  .resource-caption {
    text-align: center;
    padding: 8px;
    font-size: 15px;
    color: #444;
    line-height: 1.5;         /* 建议设置行高，使文本布局更稳定 */
    overflow: hidden;         /* 隐藏溢出内容 */
    text-overflow: ellipsis;  /* 溢出时显示省略号 */
    display: -webkit-box;     /* 启用弹性盒模型（WebKit 内核） */
    -webkit-box-orient: vertical; /* 垂直排列子元素 */
    -webkit-line-clamp: 2;    /* 限制显示的最大行数（这里是 2 行） */
    white-space: normal;      /* 允许文本自动换行 */
    word-wrap: break-word;
  }

  /* 箭头样式 */
  .scroll-arrow {
    width: 32px;
    height: 32px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .scroll-arrow img {
    width: 100%;
    height: auto;
  }

  /* 响应式处理 */
  @media (max-width: 768px) {
    .resource-container {
      flex-direction: column;
    }
    .resource-box {
      width: 100%;
      height: auto;
    }
    .resource-scroll-wrapper {
      position: static;
      height: auto;
      margin-top: 20px;
    }
  }

  /* 弹出层遮罩 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }

  /* 弹出层容器 */
  .modal-box {
    background: #fff;
    border-radius: 10px;
    width: 80%;
    max-width: 720px;
    overflow: hidden;
    box-shadow: 0 6px 24px rgba(0,0,0,0.2);
  }

  /* 弹出层顶部标题栏 */
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #f2f2f2;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }

  /* 关闭按钮 */
  .modal-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #999;
  }
  .modal-close:hover {
    color: #e74c3c;
  }

  /* 弹出层内容 */
  .modal-body {
    padding: 16px;
  }
  .modal-body video,
  .modal-body iframe {
    width: 100%;
    border-radius: 6px;
    background: #000;
  }


  .modal-tools {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .fullscreen-btn {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: #555;
  }
  .fullscreen-btn:hover {
    color: #000;
  }

  .message-info {
    display: flex;
    align-items: center;
    gap: 8px; /* 头像与名字间距 */
  }

  .avatar {
    width: 25px;
    height: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ResourceSection.vue